import React, { useState } from 'react';
import NumberFormat from 'react-number-format';
import { useIntl } from 'react-intl';
import { ReactSVG } from 'react-svg';
import CustomBtn from '../../../generic/CustomBtn';
import GeoJsonUploader from '../../../components/WizardForm/Steps/AnotherComponents/GeoJsonUploader';
import NftMap from '../../../components/Map/components/NftMap';
import reload from '../../../assets/image/reload.svg';
import MapMini from '../../../components/Map/components/MapMini/MapMini';

const UpdatedMap = ({ initState, setInitState }) => {
  const [showMap, setShowMap] = useState(false);
  const [jsonFile, setJsonFile] = useState();
  const [prevCoordinate, setPrevCordinate] = useState({});
  const translate = useIntl();
  const updateStateWithNewCoord = (newCoord) => {
    setInitState({ ...initState, ...newCoord });
  };
  const setGepjsonWithPreCoor = (obj) => {
    const {
      region,
      geoFile,
      polygon,
      polygonCoordinate,
      regionShortCode,
      square,
      cidScreenShot,
    } = initState;
    const prevObj = structuredClone({ region,
      geoFile,
      polygon,
      polygonCoordinate,
      regionShortCode,
      square,
      cidScreenShot });
    setPrevCordinate(prevObj);
    setJsonFile(obj);
  };

  const resetFile = () => {
    setInitState({ ...initState, ...prevCoordinate });
  };
  return (
    <div className="update-map">
      {showMap && (
        <NftMap
          state={initState}
          setState={updateStateWithNewCoord}
          uploadedFile={jsonFile}
          setUploadedFile={setJsonFile}
          setShow={setShowMap}
          setShowPrev={() => {}}
        />
      )}
      <div className="update-map__wrapper">
        <div className="update-map__coord">
          <p className="update-map__label">
            {translate.formatMessage({ id: 'wizardForm.step2.location' })}
          </p>
          <p className="update-map__component update-map__region">
            {initState.region}
          </p>
        </div>
        <div className="update-map__coord">
          <p className="update-map__label">
            {translate.formatMessage({ id: 'wizardForm.step2.codePlus' })}
          </p>
          <p className="update-map__component">
            {initState.codePlus}
          </p>
        </div>
        <div className="update-map__coord">
          <p className="update-map__label">
            {translate.formatMessage({ id: 'wizardForm.step3.projectArea' })}
          </p>
          <p className="update-map__component update-map__area">
            <NumberFormat
              value={initState.square}
              displayType="text"
              thousandSeparator
            />
          </p>
        </div>
      </div>
      <div className="update-map__coord-big">
        <div className="update-map__btn-map">
          <div className="update-map__location-option">
            <CustomBtn
              label={translate.formatMessage({ id: 'button-drawZone' })}
              handleClick={() => setShowMap(true)}
              iconClass="icon-marker"
              customClass="btn__map"
            />
          </div>
          <div className="update-map__location-option">
            {initState?.geoFile ? (
              <div className="update-map__geojson-wrapper">
                <p className="update-map__geojson-filename">
                  {initState?.geoFile}
                  <div className="update-map__reload-wrapper" onClick={resetFile}>
                    <ReactSVG src={reload} />
                  </div>
                </p>
              </div>

            ) : (
              <div className="update-map__location-option-uploader">
                <GeoJsonUploader
                  jsonFile={jsonFile}
                  setJsonFile={setGepjsonWithPreCoor}
                  setShowMap={setShowMap}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <MapMini state={initState} />
    </div>
  );
};

export default UpdatedMap;
